import { RoleTypes } from './RoleTypes'

export const roleTypeMappings = new Map<RoleTypes, string>([
	[RoleTypes.EXTERNAL_ROLE, 'ROLE.EXTERNAL.NAME'],
	[RoleTypes.INTERNAL_ROLE, 'ROLE.INTERNAL.NAME'],
	[RoleTypes.UNDEFINED, 'ROLE.UNKNOWN.NAME'],
])
